const matchesDashboardSection = (sectionKey, { pathname = '', search = '' } = {}) => {
  if (!pathname || !sectionKey) return false;
  const normalizedSection = String(sectionKey || '').trim().toLowerCase();
  if (!normalizedSection) return false;

  const normalizedPath = String(pathname);
  if (normalizedPath.startsWith(`/dashboard/${normalizedSection}`)) {
    return true;
  }

  if (normalizedPath === '/dashboard') {
    try {
      const params = new URLSearchParams(search || '');
      const param = params.get('section');
      return (param || '').toLowerCase() === normalizedSection;
    } catch {
      return false;
    }
  }

  return false;
};

const matchesVisitDefinition = (definition, context) => {
  if (!definition) return false;
  if (typeof definition.matcher === 'function') {
    try {
      return Boolean(definition.matcher(context));
    } catch {
      return false;
    }
  }
  if (definition.pattern instanceof RegExp) {
    return definition.pattern.test(context.pathname || '');
  }
  return false;
};

const PAGE_VISIT_DEFINITIONS = [
  {
    key: 'home',
    label: 'Inicio',
    description: 'Página principal pública',
    pattern: /^\/$/,
  },
  {
    key: 'register-choice',
    label: 'Registro (selector)',
    description: 'Pantalla de selección de tipo de registro',
    pattern: /^\/register$/,
  },
  {
    key: 'register-client',
    label: 'Registro de cliente',
    description: 'Formulario público de registro para clientes',
    pattern: /^\/register\/client$/,
  },
  {
    key: 'register-provider',
    label: 'Registro de proveedor',
    description: 'Formulario público de registro para proveedores',
    pattern: /^\/register\/provider$/,
  },
  {
    key: 'marketplace',
    label: 'Marketplace',
    description: 'Explorador de publicaciones destacadas',
    pattern: /^\/marketplace$/,
  },
  {
    key: 'requests-marketplace',
    label: 'Solicitudes abiertas',
    description: 'Marketplace público de solicitudes',
    pattern: /^\/solicitudes$/,
  },
  {
    key: 'request-detail',
    label: 'Detalle de solicitud',
    description: 'Detalle público de una solicitud específica',
    pattern: /^\/solicitudes\/[^/]+$/,
  },
  {
    key: 'listing-detail',
    label: 'Detalle de listing',
    description: 'Vista pública de una publicación SEO',
    pattern: /^\/listing\/.+$/,
  },
  {
    key: 'publication-detail',
    label: 'Detalle de publicación',
    description: 'Vista técnica de una publicación',
    pattern: /^\/publicaciones\/[^/]+(?:\/reservar)?$/,
  },
  {
    key: 'dashboard-feed',
    label: 'Feed (panel)',
    description: 'Resumen privado de actividad para miembros logueados',
    matcher: context => matchesDashboardSection('feed', context),
  },
];

const FALLBACK_PAGE_DEFINITION = {
  key: 'other',
  label: 'Otras páginas',
  description: 'Sección general para rutas públicas no clasificadas',
};

export function resolvePageVisitDefinition(pathname, search = '') {
  if (!pathname) return null;
  const context = { pathname, search };
  return PAGE_VISIT_DEFINITIONS.find(entry => matchesVisitDefinition(entry, context)) || null;
}

export function resolvePageVisitLabel(pathname, search = '') {
  const definition = resolvePageVisitDefinition(pathname, search);
  return definition ? definition.label : FALLBACK_PAGE_DEFINITION.label;
}

export function resolveOrFallbackPageVisit(pathname, search = '') {
  return resolvePageVisitDefinition(pathname, search) || FALLBACK_PAGE_DEFINITION;
}

export function getTrackedPageVisitKeys() {
  return PAGE_VISIT_DEFINITIONS.map(entry => entry.key);
}

export function getPageVisitDefinitions() {
  return PAGE_VISIT_DEFINITIONS.slice();
}

export const PAGE_VISIT_FALLBACK = FALLBACK_PAGE_DEFINITION;
